var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"authorization-container"},[_c('SiteLogo'),(_vm.tabIndex === _vm.LoginTabId)?_c('AuthorizationForm',{ref:"authForm",on:{"authenticated":_vm.onSuccessAuth}}):_vm._e()],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }